import { xhrClient } from '@/config/axiosClient'
import { ResendRedemptionEmailInput } from '@/dto/ResendRedemptionEmailInput'

export const postOrderStatusResendEmail = async (
    body: ResendRedemptionEmailInput
): Promise<PostOrderStatusResendResponseBody> => {
    const { data } = await xhrClient.post(`/api/resend-redemption-email`, body)

    return data
}

export type PostOrderStatusResendResponseBody = {
    message: string
    resentTo: string
}

export default postOrderStatusResendEmail
